import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import DropdownMenu from "./DropdownMenu";
import MobileMenu from "./MobileMenu";
import "./styles/Navbar.css";
import Logo from "../../../assets/images/Logo/LOGO.png"
import { useAuth } from "../../../context/AuthContext";

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navigate = useNavigate();
  const { user, logout } = useAuth();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  const servicesItems = {
    managedServices: [
      { label: "Collaboration Solutions", href: "/services/Collaboration-Solutions" },
      { label: "Unified Communications as a service", href: "/services/Unified-Communications" },
      { label: "Contact Center as a service", href: "/services/Contact-Center" },
      { label: "Security Solutions", href: "/services/Security-Solutions" },
      { label: "Connectivity", href: "/services/Connectivity" },
      { label: "Hybrid Cloud Hosting", href: "/services/Hybrid-Cloud-Hosting" },
      { label: "Cyber Security Infrastructure", href: "/services/Cyber-Security-Infrastructure" },
    ],
      infrastructureServices: [
        { label: "Cloud Infrastructure", href: "/services/Cloud-Infrastructure" },
        { label: "Data Center Services", href: "/services/Data-Center-Services" },
        { label: "Network Infrastructure", href: "/services/Network-Infrastructure" },
        { label: "Wireless Infrastructure", href: "/services/Wireless-Infrastructure" },
        { label: "Cabling Solutions", href: "/services/Cabling-Solutions" },
        { label: "Maritime Systems", href: "/services/Maritime-Systems" },
        { label: "Intelligent Smart Cities Solutions", href: "/services/Intelligent-Smart-Cities-Solutions" },
    ],

  };

  return (
    <>
      <motion.header
        className={`navbar ${isScrolled ? "navbar--scrolled" : ""}`}
        initial={{ y: -80, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.55, ease: "easeOut" }}
      >
        <nav className="navbar__container">
        {/* Logo */}
        <Link to="/" className="navbar__logo">
            <img
              src={Logo}
              alt="ComNetworks"
              className="navbar__logo-img"
            />
          </Link>

        {/* Desktop Navigation */}
        <div className="navbar__menu">
          {/*<Link to="/services" className="navbar__link">
            Services
          </Link>
          <DropdownMenu title="Resources" items={resourcesItems} />
          <DropdownMenu title="About" items={aboutItems} />*/}
<DropdownMenu className="navbar__service_btn" title="Services" items={servicesItems} isScrolled={isScrolled} />
          <Link to="/Partners" className="navbar__link">
            Partners
          </Link>
          <Link to="/About" className="navbar__link">
            About
          </Link>
          
        </div>

        {/* Right Side Actions */}
        <div className="navbar__actions">
          {/* Search Icon 
          <button className="navbar__search-btn" aria-label="Search">
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              className="navbar__icon" 
              fill="none" 
              viewBox="0 0 24 24" 
              stroke="currentColor"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" 
              />
            </svg>
          </button>*/}

          {/* Auth buttons BEFORE login, CTA AFTER login */}
          {!user ? (
            <div className="navbar__auth-cta">
              <button
  type="button"
  className="navbar__auth-btn navbar__auth-btn--ghost"
  onClick={() => navigate('/login')}
>
  Login
</button>

<button
  type="button"
  className="navbar__auth-btn navbar__auth-btn--solid"
  onClick={() => navigate('/register')}
>
  Sign up
</button>

            </div>
          ) : (
            <div className="navbar__auth-cta">
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="navbar__cta-btn"
                onClick={() => navigate('/contact')}
              >
                LET&apos;S MEET
              </motion.button>
              {user && (
  <div className="navbar__user">
    <button className="navbar__user-btn" aria-label="User menu">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="navbar__icon"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M5.121 17.804A13.937 13.937 0 0112 15c2.5 0 4.847.655 6.879 1.804M15 11a3 3 0 11-6 0 3 3 0 016 0z"
        />
      </svg>
    </button>

    <div className="navbar__user-dropdown">
      {user.role === 'ADMIN' && (
        <Link to="/admin">Admin Panel</Link>
      )}
      
      <Link
        to={user.role === 'ADMIN' ? '/admin/knowledge-base' : '/knowledge-base'}
      >
        Knowledge Base
      </Link>

      <Link to="/settings">Settings</Link>

      <Link to="/tickets">Support Tickets</Link>

      <button onClick={handleLogout} className="logout-btn">
        Logout
      </button>
    </div>
  </div>
)}
            </div>
          )}



          {/* Mobile Menu Toggle */}
          <button
            className="navbar__mobile-toggle"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="navbar__icon"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              {isMobileMenuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>
        </div>
      </nav>
      </motion.header>

      <AnimatePresence>
        {isMobileMenuOpen && (
          <MobileMenu onClose={() => setIsMobileMenuOpen(false)} />
        )}
      </AnimatePresence>
    </>
  );
};

export default Navbar;
